import React from 'react';

import { type FEmailMessageFragment, useTriggerEmailMessageFailMutation } from '@dashboard/generated/wp/administrator';
import { Button } from '@mui/material';

type Props = {
  emailMessage: FEmailMessageFragment;
};

export default function TriggerFailButton({ emailMessage }: Props) {
  const [trigger, { loading: disabled }] = useTriggerEmailMessageFailMutation();

  const status = emailMessage.status;
  switch (status) {
    case 'DELETED':
    case 'PAUSED':
    case 'SUCCEEDED':
    case 'FAILED':
      return null;
  }

  const onClick = () => {
    trigger({ variables: { id: emailMessage.id } });
  };
  return (
    <Button variant="contained" disabled={disabled} onClick={onClick}>
      Fail
    </Button>
  );
}
